// Production flow switches. Set a flow to false to redirect all its pages to /new-h2.
// Staging and localhost stay available unless production emulation is enabled.
// Changes take effect after deployment. Keep new-h2 enabled as the redirect target.
export const productionFlows: Readonly<Record<string, boolean>> = {
    'new-h': true,
    'new-h2': true,
    'new-s': true,
    'new-t': true,
    'new-t2': false,
    'iq-test': true,
    'hp': false,
    'hp-3': false,
    'hp-23d': false,
    'apply-discount': true,
    'learning-desk-1': true,
    'w2a': true,
};
